import { appStore } from "entities/App";
import { ParcelSearchRequestFunc } from "entities/ParcelSearchCard";
import { useSearchQuery, UseSearchQueryReturnType } from "entities/ParcelSearchCard";
import { subscriptionStore } from "entities/Subscription";

type UseParcelSearchReturnType = {
  parcelSearchRequest: ParcelSearchRequestFunc;
  parcelSearchResponse: UseSearchQueryReturnType["searchResponse"];
  isParcelSearchLoading: boolean;
  isParcelSearchSuccess: boolean;
  isParcelSearchError: boolean;
};

export const useParcelSearch = ({ isAuthenticated }: { isAuthenticated: boolean }): UseParcelSearchReturnType => {
  const { searchRequest, searchResponse, isSearchSuccess, isSearchError, isSearchLoading } = useSearchQuery({
    isAuthenticated,
    setSubscription: (subscription) => ({
      type: subscriptionStore.actions.setSubscription.type,
      payload: subscription,
    }),
    setActivePaymentModal: (activePaymentModal) => ({
      type: subscriptionStore.actions.setActivePaymentModal.type,
      payload: activePaymentModal,
    }),
    setAppIntegrationRequestLimitReached: (appIntegrationRequestLimitReached) => ({
      type: appStore.actions.setAppIntegrationRequestLimitReached.type,
      payload: appIntegrationRequestLimitReached,
    }),
    setWebAppRequestLimitReached: (webAppRequestLimitReached) => ({
      type: appStore.actions.setWebAppRequestLimitReached.type,
      payload: webAppRequestLimitReached,
    }),
  });

  return {
    parcelSearchRequest: searchRequest,
    parcelSearchResponse: searchResponse,
    isParcelSearchLoading: isSearchLoading,
    isParcelSearchSuccess: isSearchSuccess,
    isParcelSearchError: isSearchError,
  };
};
